// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminGuaranteeListItemResponse

import { GuaranteeStatus, BookingStatus } from './enums.gen';
import { hydrateAdminBusinessReference, type AdminBusinessReference, type AdminBusinessReferenceApiResponse } from './adminBusinessReference.gen';
import { hydrateAdminBookingCustomer, type AdminBookingCustomer, type AdminBookingCustomerApiResponse } from './adminBookingCustomer.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminGuaranteeListItemApiResponse = {
	id: number;
	business: AdminBusinessReferenceApiResponse;
	amount: number;
	fee: number;
	status: GuaranteeStatus;
	operation: string;
	method: string;
	type: string;
	createdAt: string;
	effective_date: string;
	bookingId: string;
	booking_id: string;
	booking_date: string;
	booking_status: BookingStatus;
	booking_pax: number;
	failureMessage: string | null;
	customer: AdminBookingCustomerApiResponse | null;
	paymentIntentId: string | null;
	customer_id: string | null;
	customer_name: string | null;
	customer_firstname: string | null;
	customer_lastname: string | null;
	customer_email: string | null;
	customer_phone: string | null;
};

export type AdminGuaranteeListItem = {
	id: number;
	business: AdminBusinessReference;
	amount: number;
	fee: number;
	status: GuaranteeStatus;
	operation: string;
	method: string;
	type: string;
	createdAt: DateTime;
	effective_date: DateTime;
	bookingId: string;
	booking_id: string;
	booking_date: DateTime;
	booking_status: BookingStatus;
	booking_pax: number;
	failureMessage: string | null;
	customer: AdminBookingCustomer | null;
	paymentIntentId: string | null;
	customer_id: string | null;
	customer_name: string | null;
	customer_firstname: string | null;
	customer_lastname: string | null;
	customer_email: string | null;
	customer_phone: string | null;
};

export function hydrateAdminGuaranteeListItem(data: AdminGuaranteeListItemApiResponse): AdminGuaranteeListItem {
	return {
		...data,
		business: hydrateAdminBusinessReference(data.business),
		createdAt: DateTimefromISO(data.createdAt)!,
		effective_date: DateTimefromISO(data.effective_date)!,
		booking_date: DateTimefromISO(data.booking_date)!,
		customer: data.customer ? hydrateAdminBookingCustomer(data.customer) : null,
	};
}